import React from 'react'
import IconLabel from '../../common/icon-label'
import { AwardFill } from 'react-bootstrap-icons'

const CreditsIconLabel = ({
    experience = {}
}) => {

    return (
        <IconLabel
            icon={AwardFill}
        >
            {experience.credits}
        </IconLabel>
    )
}

export default CreditsIconLabel